import script from "./DashboardsSubsidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardsSubsidebar.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardsSubsidebar.vue?vue&type=style&index=0&id=4fe4c404&lang=scss"

const __exports__ = script;

export default __exports__